var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotFound"},[_c('v-card-text',[_c('v-layout',{attrs:{"justify-start":""}},[_c('span',{staticClass:"display-1 primary--text mb-2"},[_vm._v("NotFound")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }